import { DatePicker, Input, Select, TextArea } from "common/InputForm";
import useButtonLoader from "hooks/useButtonLoader";
import React, { useEffect, useState } from "react";
import { IoChevronBack } from "react-icons/io5";
import { RiArrowLeftSLine } from "react-icons/ri";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  addPromoCodeApi,
  editPromoCodeApi,
  getPromoCodeDetailApi,
} from "services/promocode";
import { toastMessage } from "utils/toastMessage";

const UpdatePromoCode = () => {
  const [error, setError] = useState({});
  const [buttonLoader, setButtonLoader] = useButtonLoader("Update");
  const navigate = useNavigate();
  const id = useParams();
  const [input, setInput] = useState({
    couponCode: "",
    discountType: "",
    minAmount: "",
    perUserLimit: "",
    discountValue: "",
    description: "",
    startDate: "",
    endDate: "",
  });
  // console.log({ input, type, promoCodeId })
  const isDiscountType = input?.discountType || "";
  // -----------handle-Date-change---------------
  const handleDateChange = (name, date) => {
    setInput({ ...input, [name]: date });
  };

  const fetchSelectedPromoCodeDetails = async () => {
    try {
      const {
        data: { status, code, data },
      } = await getPromoCodeDetailApi(id);
      if (status || code === 200) {
        console.log(data, "getData");
        setInput({
          couponCode: data?.couponCode || "",
          discountType: data?.discountType || "",
          minAmount: data?.minAmount || "",
          perUserLimit: data?.perUserLimit || "",
          discountValue: data?.discountValue || "",
          description: data?.description || "",
          startDate: data?.startDate || "",
          endDate: data?.endDate || "",
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchSelectedPromoCodeDetails();
  }, []);

  // -----------handle-onchange----------------
  const handleChanges = (e) => {
    const { name, value } = e.target;
    const noLeadSpace = value.replace(/^\s+/, ""); // Remove leading spaces

    if (name === "couponCode") {
      const couponCode = noLeadSpace.replace(/[^a-zA-Z0-9]/g, "");
      setInput({ ...input, [name]: couponCode });
      return;
    }
    if (name === "discountType") {
      setInput({ ...input, discountType: noLeadSpace, discountValue: "" });
      return;
    }

    if (
      name === "minAmount" ||
      name === "perUserLimit" ||
      name === "discountValue"
    ) {
      // ✅ Only Numbers Allowed, No Spaces
      const numberValue = noLeadSpace.replace(/[^0-9]/g, "");
      setInput({ ...input, [name]: numberValue });
      return;
    }

    // ✅ For other fields, allow text without leading space
    setInput({ ...input, [name]: noLeadSpace });
  };


  const handleChange = (e) => {
  const { name, value } = e.target;

  if (name === "couponCode") {
    // Allow letters, numbers, spaces and special characters
    // but don't allow spaces at the beginning
    const couponCode = value.replace(/^\s+/, "");

    setInput((prev) => ({
      ...prev,
      [name]: couponCode,
    }));
    return;
  }

  if (name === "discountType") {
    setInput((prev) => ({
      ...prev,
      discountType: value.trimStart(),
      discountValue: "",
    }));
    return;
  }

  if (
    name === "minAmount" ||
    name === "perUserLimit" ||
    name === "discountValue"
  ) {
    // Only numbers
    const numberValue = value.replace(/[^0-9]/g, "");

    setInput((prev) => ({
      ...prev,
      [name]: numberValue,
    }));
    return;
  }

  // Other fields: don't allow leading spaces
  const noLeadSpace = value.replace(/^\s+/, "");

  setInput((prev) => ({
    ...prev,
    [name]: noLeadSpace,
  }));
};
  // ------------validation-----------------
  const validation = () => {
    let errorMessage = {};
    let status = true;

    if (!input.couponCode) {
      errorMessage["couponCode"] = "Please enter coupon code";
      status = false;
    }

    if (!input.discountType) {
      errorMessage["discountType"] = "Please select discount type";
      status = false;
    }

    if (!input.discountValue) {
      errorMessage["discountValue"] = "Please enter discount value";
      status = false;
    }

    if (!input.minAmount) {
      errorMessage["minAmount"] = "Please enter minimum order amount";
      status = false;
    }

    if (!input.perUserLimit) {
      errorMessage["perUserLimit"] = "Please enter per user limit";
      status = false;
    }

    if (!input.description) {
      errorMessage["description"] = "Please enter description";
      status = false;
    }

    if (!input.startDate) {
      errorMessage["startDate"] = "Please select start date";
      status = false;
    }

    if (!input.endDate) {
      errorMessage["endDate"] = "Please select end date";
      status = false;
    }

    setError(errorMessage);
    return status;
  };
  // ------------update-promo-code-API--------------------
  const submitPromoCode = async () => {
    if (validation()) {
      try {
        const { name, ...rest } = input;
        setButtonLoader(true);
        const res = await editPromoCodeApi(id, rest);
        const { code, message } = res?.data;
        if (code === 200) {
          toastMessage(message, "success", "updatePromoCode");
          navigate(-1);
        }
      } catch (e) {
        console.log("e", e);
      } finally {
        setButtonLoader(false);
      }
    }
  };

  return (
    <div className="add-cat-parent-container">
      <div className="link-header-holder">
        <p>
          <Link to={-1}>
            <IoChevronBack />
            Back
          </Link>
          <span>Manage Coupon Code</span>
          &nbsp;
          <span>/ Update Promo Code </span>
        </p>
      </div>
      <div className="sub_title has_button">
        <Link to={-1}>
          <RiArrowLeftSLine />
        </Link>{" "}
        <h3>Update Promo Code</h3>
      </div>

      <div className="card">
        <div className="form_field_wrap">
          <div className="form_field">
            <Input
              type="text"
              label="ID"
              placeholder="Enter couponCode"
              name="couponCode"
              maxLength={25}
              value={input?.couponCode}
              onChange={handleChange}
              error={error.couponCode}
            />
          </div>
          <div className="form_field">
            <Select
              type="text"
              label="Discount Type"
              name="discountType"
              value={input?.discountType}
              onChange={handleChange}
              error={error.discountType}
              disabled // ✅ field disable
            >
              <option value="" disabled>
                select Discount
              </option>
              <option value="FIXED">fixed</option>
              <option value="PERCENTAGE">percentage</option>
            </Select>
          </div>
        </div>

        <div className="form_field_wrap">
          <div className="form_field">
            <Input
              type="text"
              label="Min. Order Amount to Apply Promocode"
              placeholder="Enter minimum order amount"
              name="minAmount"
              maxLength={25}
              value={input?.minAmount}
              onChange={handleChange}
              error={error.minAmount}
            />
          </div>
          <div className="form_field">
            <Input
              type="text"
              label="No. of Times Promocode Can Be Used by a User"
              placeholder="Enter usage limit per user"
              name="perUserLimit"
              maxLength={25}
              value={input?.perUserLimit}
              onChange={handleChange}
              error={error.perUserLimit}
            />
          </div>
          <div className="form_field">
            <Input
              type="text"
              label={`Discount ${isDiscountType ? `(${isDiscountType === "PERCENTAGE" ? "%" : "₹"})` : ""}`}
              name="discountValue"
              value={input?.discountValue}
              onChange={handleChange}
              disabled // ✅ field disable
              placeholder={
                isDiscountType
                  ? `Enter discount ${isDiscountType === "PERCENTAGE" ? "(in %)" : "(in ₹)"}`
                  : "Select discount type first"
              }
              // disabled={!isDiscountType}
              error={error.discountValue}
              maxLength={isDiscountType === "PERCENTAGE" ? 2 : 9}
            />
          </div>
        </div>

        <div className="form_field_wrap">
          <div className="form_field">
            <TextArea
              label="Description"
              placeholder="Enter description"
              name="description"
              maxLength={250}
              value={input?.description}
              onChange={handleChange}
              error={error?.description}
            />
          </div>
        </div>

        <div className="form_field_wrap">
          <div className="form_field">
            <DatePicker
              name="startDate"
              label="Start Date"
              selected={input?.startDate}
              placeholder="Start Date"
              onChange={(date) => handleDateChange("startDate", date)}
              maxDate={input?.endDate}
              minDate={new Date()}
              error={error.startDate}
            />
          </div>
          <div className="form_field">
            <DatePicker
              name="endDate"
              label="End Date"
              selected={input?.endDate}
              placeholder="End Date"
              onChange={(date) => handleDateChange("endDate", date)}
              minDate={input?.startDate || new Date()}
              error={error.endDate}
            />
          </div>
          <div className="form_field mt-2">
            <div className="submit-button-holder mt-4">
              <button
                type="button mt-1"
                className="button"
                ref={buttonLoader}
                onClick={submitPromoCode}
              >
                Update
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdatePromoCode;